import axios from 'axios'

const baseurl = `${process.env.VUE_APP_API_URL}`
const url = `${baseurl}/api/v1`
class StageOneService {
  static getStageOne (id) {
    return axios.get(`${url}/admin/stage-one/fetch/${id}`)
  }
}

export default StageOneService
